import { render, staticRenderFns } from "./GoodsSettingCustomBriefStyle.vue?vue&type=template&id=fd0f9d84&scoped=true&"
import script from "./GoodsSettingCustomBriefStyle.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingCustomBriefStyle.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingCustomBriefStyle.vue?vue&type=style&index=0&id=fd0f9d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0f9d84",
  null
  
)

export default component.exports